import { reject } from 'lodash/fp';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import { updateItem } from 'utils/fp';

export default (sessions = [], action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.SESSIONS.CREATE:
      return [action.session, ...sessions];

    case IN_PERSON_TRAINING.SESSIONS.REMOVE:
      return reject({ id: action.session.id }, sessions);

    case IN_PERSON_TRAINING.SESSIONS.UPDATE:
      return updateItem(
        sessions,
        { id: action.session.id },
        action.session,
        false,
      );
    case IN_PERSON_TRAINING.EVENT.DATA_RECEIVE:
      return action.sessions;
    default:
      return sessions;
  }
};
